import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';
import SEO from '../components/common/SEO';

const BRAND = '#6B8E23';

const webinarSeries = [
    {
        date: 'Thursday, October 1, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Interventions to Reduce Childhood Mortality Due to Pneumonia',
        speaker: 'Michael D. Davis, RRT, PhD, FAARC',
        profile: 'Associate Research Professor of Pediatrics, Herman B Wells Center for Pediatric Research, Pediatric Pulmonology, Allergy, and Sleep Medicine, Indiana University School of Medicine, USA.'
    },
    {
        date: 'Saturday, October 3, 2026',
        time: '9:00 AM EST | 8:00 AM CST | 1:00 PM GMT',
        title: 'Standardizing Liberation from Mechanical Ventilation: Building Protocolized Weaning Pathways in Africa',
        speaker: 'Hanan Ali Mohammed, Respiratory Care Practitioner, MSRT, MPH',
        profile: 'President, Ethiopia Association for Respiratory Care; Deputy Country Director for Ethiopia, Africa Respiratory Care Association.'
    },
    {
        date: 'Thursday, October 8, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Beyond the Bleeding: The Respiratory Therapist’s Role in Postpartum Hemorrhage and Maternal Survival',
        speaker: 'Dr. Peter Jaswilko, EdD, MSRC, RRT, RRT-ACCS, RRT-NPS, RRT-SDS, RPFT, AE-C',
        profile: 'Department Chair and Professor of Allied Health, Triton College, Illinois, USA; Part-Time Faculty, Respiratory Care Program, Boise State University, Idaho, USA; Advanced Respiratory Therapist, Mercy Health, Illinois and Wisconsin, USA; Global Health Consultant and International Educator.'
    },
    {
        date: 'Saturday, October 10, 2026',
        time: '9:00 AM EST | 8:00 AM CST | 1:00 PM GMT',
        title: 'Cultural Competence in Healthcare: Bridging the Gaps',
        speaker: 'Mulenga Chanka',
        profile: 'Respiratory Therapy Manager, Advocate Health, Illinois, USA.'
    },
    {
        date: 'Thursday, October 15, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Empowering Communities to Breathe: Guyana’s Model for Integrated, Equitable Respiratory Care',
        speaker: 'Dr. Bibi Waleema Bacchus-Ali',
        profile: 'Respiratory Medicine and Allergy, Pulmonologists GHPC, Guyana.'
    },
    {
        date: 'Thursday, October 22, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Lung-Protective Strategies During Neonatal Resuscitation',
        speaker: 'Prof. Rania Ali El-Farrash, MD, PhD',
        profile: 'Professor of Pediatrics and Consultant Neonatologist, Faculty of Medicine, Ain Shams University, Cairo, Egypt.'
    },
    {
        date: 'Thursday, October 29, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Evidence-Based Leadership in Healthcare',
        speaker: 'Dr. Olugbenga Agbelemose, EdD, MBA, RCP, RRT-NPS, CPFT',
        profile: 'Associate Professor, Chuck Lorrie Allied Health School, Cedars-Sinai University, California, USA.'
    },
    {
        date: 'Saturday, October 31, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Awake and Walking ICUs: True Mastery of the ABCDEF Bundle',
        speaker: 'Kali Dayton, DNP, AGACNP',
        profile: 'Spokane, Washington, USA.'
    },
    {
        date: 'Thursday, November 12, 2026',
        time: '12:00 PM EST | 11:00 AM CST | 4:00 PM GMT',
        title: 'Point-of-Care Ultrasound: Reshaping the Future of Respiratory Therapy',
        speaker: 'Dr. Joseph Williamson',
        profile: 'Sonologist and High-Risk Maternal-Fetal Specialist; Chief Executive Officer, QualCare-Africa.'
    }
];

const ahpcProfessions = [
    { value: 'MLS', label: 'Medical Laboratory Scientist' },
    { value: 'SON', label: 'Sonographer' },
    { value: 'HIO', label: 'Health Information Officer' },
    { value: 'DRA', label: 'Radiographer' },
    { value: 'RTP', label: 'Respiratory Therapist' },
    { value: 'HPO', label: 'Health Promotion Officer' },
    { value: 'PHT', label: 'Physiotherapist' },
    { value: 'MPT', label: 'Medical Physicist' },
    { value: 'MRA', label: 'Medical Record Assistant' },
    { value: 'PTA', label: 'Physiotherapy Technician/Assistant' },
    { value: 'DSC', label: 'Disease Control Officer' },
    { value: 'NUT', label: 'Nutritionist' },
    { value: 'Others', label: 'Others' }
];

const nmcProfessions = [
    { value: 'NAC', label: 'Nurse Assistant – Clinical' },
    { value: 'NAP', label: 'Nurse Assistant – Preventive' },
    { value: 'RGN', label: 'Registered General Nurse' },
    { value: 'RM', label: 'Registered Midwife' },
    { value: 'RCN', label: 'Registered Community Nurse' },
    { value: 'RMN', label: 'Registered Mental Health Nurse' },
    { value: 'RPHN', label: 'Registered Public Health Nurse' },
    { value: 'PNNM', label: 'Post NAC/NAP Midwifery' },
    { value: 'PHN', label: 'Public Health Nurse' },
    { value: 'OPN', label: 'Ophthalmic Nurse' },
    { value: 'PON', label: 'Peri-Operative Nurse' },
    { value: 'CCN', label: 'Critical Care Nurse' },
    { value: 'ENT', label: 'Ear, Nose and Throat Nurse' },
    { value: 'PN', label: 'Paediatric Nurse' },
    { value: 'EN', label: 'Emergency Nurse' },
    { value: 'NP', label: 'Nurse Practitioner' },
    { value: 'Others', label: 'Others' }
];

const initialForm = {
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    governingBody: '',
    profession: '',
    professionOther: '',
    pin: '',
    email: '',
    emailConfirm: '',
    phone: '',
    momoTransactionId: ''
};

const CpdRegistrationPage = () => {
    const [step, setStep] = useState(1);
    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: undefined }));
    };

    const handleGoverningBodyChange = (e) => {
        const value = e.target.value;
        setForm(prev => ({
            ...prev,
            governingBody: value,
            profession: '',
            professionOther: '',
            pin: ''
        }));
        setErrors(prev => ({ ...prev, governingBody: undefined, profession: undefined, pin: undefined }));
    };

    const validateStep1 = () => {
        const newErrors = {};
        if (!form.firstName.trim()) newErrors.firstName = 'First Name is required';
        if (!form.lastName.trim()) newErrors.lastName = 'Last Name is required';
        if (!form.gender) newErrors.gender = 'Gender is required';
        if (!form.governingBody) newErrors.governingBody = 'Professional Governing Body is required';
        if (!form.profession) newErrors.profession = 'Profession is required';
        if (form.profession === 'Others' && !form.professionOther.trim()) {
            newErrors.professionOther = 'Please specify your profession';
        }
        if (!form.pin.trim()) newErrors.pin = 'PIN/Registration Number is required';
        if (!form.email.trim()) newErrors.email = 'Primary Email Address is required';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) newErrors.email = 'Please enter a valid email address';
        if (!form.emailConfirm.trim()) newErrors.emailConfirm = 'Email Address Confirmation is required';
        else if (form.email !== form.emailConfirm) newErrors.emailConfirm = 'The email addresses do not match. Please check both email fields and try again.';
        if (!form.phone.trim()) newErrors.phone = 'Telephone Number is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateStep2 = () => {
        const newErrors = {};
        if (!form.momoTransactionId.trim()) {
            newErrors.momoTransactionId = 'Payment is required. Please complete your payment and enter your MoMo Payment Transaction ID before continuing.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleContinueToReview = () => {
        if (validateStep1() && validateStep2()) {
            setStep(3);
        }
    };

    const handleSubmit = async () => {
        if (!validateStep1() || !validateStep2()) return;
        setSubmitting(true);
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
            const response = await fetch(`${API_URL}/cpd-registrations`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form)
            });
            const data = await response.json();
            if (data.success) {
                setSubmitted(true);
                setStep(4);
            } else {
                setErrors({ submit: data.message || 'Failed to submit registration. Please try again.' });
            }
        } catch (error) {
            setErrors({ submit: 'Failed to submit registration. Please try again.' });
        } finally {
            setSubmitting(false);
        }
    };

    const renderProgress = () => (
        <div className="d-flex justify-content-between mb-4">
            {['Personal Information', 'Payment', 'Review', 'Confirmation'].map((label, idx) => (
                <div key={label} className="text-center flex-fill">
                    <div
                        className="rounded-circle mx-auto d-flex align-items-center justify-content-center fw-bold"
                        style={{
                            width: 40,
                            height: 40,
                            backgroundColor: step > idx + 1 ? BRAND : step === idx + 1 ? BRAND : '#e9ecef',
                            color: step >= idx + 1 ? '#fff' : '#6c757d'
                        }}
                    >
                        {idx + 1}
                    </div>
                    <small className="d-none d-md-block mt-1" style={{ fontSize: '0.75rem' }}>{label}</small>
                </div>
            ))}
        </div>
    );

    return (
        <PublicLayout>
            <SEO title="CPD Registration - Respiratory Care Month 2026 | ARCA" />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="mb-4">
                            <Link to="/events" className="btn btn-outline-secondary btn-sm mb-3">
                                <i className="fas fa-arrow-left me-2"></i>Back to Events
                            </Link>
                            <h1 className="fw-bold mb-3" style={{ color: '#4A4F4F' }}>
                                CPD Registration (Ghana/Africa)
                            </h1>
                            <p className="text-muted mb-0">
                                Register for the Respiratory Care Month 2026 Webinar Series and earn CPD points.
                            </p>
                        </div>

                        {/* Webinar Series Schedule */}
                        <div className="card border-0 mb-4 shadow-sm">
                            <div className="card-header text-white fw-bold" style={{ backgroundColor: BRAND }}>
                                <i className="fas fa-calendar-alt me-2"></i>
                                Respiratory Care Month 2026 Webinar Series
                            </div>
                            <div className="card-body p-0">
                                {webinarSeries.map((webinar, idx) => (
                                    <div
                                        key={idx}
                                        className="p-3 p-md-4 border-bottom"
                                        style={{ borderColor: '#e9ecef' }}
                                    >
                                        <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
                                            <h6 className="fw-bold mb-1 mb-md-0" style={{ color: '#4A4F4F' }}>{webinar.title}</h6>
                                            <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>{webinar.date}</small>
                                        </div>
                                        <p className="small text-muted mb-1"><i className="far fa-clock me-2"></i>{webinar.time}</p>
                                        <p className="small fw-medium mb-1" style={{ color: BRAND }}><i className="fas fa-user me-2"></i>{webinar.speaker}</p>
                                        <p className="small text-muted mb-0">{webinar.profile}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Registration Form */}
                        <div className="card border-0 shadow-sm">
                            <div className="card-header text-white fw-bold" style={{ backgroundColor: BRAND }}>
                                <i className="fas fa-edit me-2"></i>CPD Registration Application
                            </div>
                            <div className="card-body p-3 p-md-4">
                                {renderProgress()}

                                {errors.submit && (
                                    <div className="alert alert-danger" role="alert">
                                        {errors.submit}
                                    </div>
                                )}

                                {step === 1 && (
                                    <>
                                        <h5 className="fw-bold mb-3">Step 1: Personal & Professional Information</h5>

                                        <div className="row g-3 mb-4">
                                            <div className="col-md-4">
                                                <label className="form-label">First Name *</label>
                                                <input type="text" name="firstName" className={`form-control ${errors.firstName ? 'is-invalid' : ''}`} value={form.firstName} onChange={handleChange} />
                                                {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Middle Name</label>
                                                <input type="text" name="middleName" className="form-control" value={form.middleName} onChange={handleChange} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Last Name *</label>
                                                <input type="text" name="lastName" className={`form-control ${errors.lastName ? 'is-invalid' : ''}`} value={form.lastName} onChange={handleChange} />
                                                {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                                            </div>
                                        </div>

                                        <div className="row g-3 mb-4">
                                            <div className="col-md-6">
                                                <label className="form-label">Gender *</label>
                                                <select name="gender" className={`form-select ${errors.gender ? 'is-invalid' : ''}`} value={form.gender} onChange={handleChange}>
                                                    <option value="">Select gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                                {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
                                            </div>
                                        </div>

                                        <h6 className="fw-bold mb-3">Professional Information</h6>
                                        <div className="row g-3 mb-4">
                                            <div className="col-md-6">
                                                <label className="form-label">Professional Governing Body *</label>
                                                <select name="governingBody" className={`form-select ${errors.governingBody ? 'is-invalid' : ''}`} value={form.governingBody} onChange={handleGoverningBodyChange}>
                                                    <option value="">Select governing body</option>
                                                    <option value="AHPC">AHPC — Allied Health Professions Council</option>
                                                    <option value="NMC">NMC — Nursing and Midwifery Council</option>
                                                </select>
                                                {errors.governingBody && <div className="invalid-feedback">{errors.governingBody}</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Profession *</label>
                                                <select name="profession" className={`form-select ${errors.profession ? 'is-invalid' : ''}`} value={form.profession} onChange={handleChange} disabled={!form.governingBody}>
                                                    <option value="">{form.governingBody ? 'Select profession' : 'Select governing body first'}</option>
                                                    {(form.governingBody === 'AHPC' ? ahpcProfessions : form.governingBody === 'NMC' ? nmcProfessions : []).map(p => (
                                                        <option key={p.value} value={p.value}>{p.label}</option>
                                                    ))}
                                                </select>
                                                {!form.governingBody && <div className="form-text text-danger">Please select a Professional Governing Body above to activate the Profession field.</div>}
                                                {errors.profession && <div className="invalid-feedback">{errors.profession}</div>}
                                            </div>
                                        </div>

                                        {form.profession === 'Others' && (
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-6">
                                                    <label className="form-label">Please specify your profession *</label>
                                                    <input type="text" name="professionOther" className={`form-control ${errors.professionOther ? 'is-invalid' : ''}`} value={form.professionOther} onChange={handleChange} />
                                                    {errors.professionOther && <div className="invalid-feedback">{errors.professionOther}</div>}
                                                </div>
                                            </div>
                                        )}

                                        <div className="row g-3 mb-4">
                                            <div className="col-md-6">
                                                <label className="form-label">{form.governingBody === 'NMC' ? 'NMC PIN/Professional Registration Number *' : 'AHPC PIN *'}</label>
                                                <input type="text" name="pin" className={`form-control ${errors.pin ? 'is-invalid' : ''}`} value={form.pin} onChange={handleChange} />
                                                {errors.pin && <div className="invalid-feedback">{errors.pin}</div>}
                                            </div>
                                        </div>

                                        <h6 className="fw-bold mb-3">Contact Information</h6>
                                        <div className="row g-3 mb-4">
                                            <div className="col-md-6">
                                                <label className="form-label">Primary Email Address *</label>
                                                <input type="email" name="email" className={`form-control ${errors.email ? 'is-invalid' : ''}`} value={form.email} onChange={handleChange} />
                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Email Address Confirmation *</label>
                                                <input type="email" name="emailConfirm" className={`form-control ${errors.emailConfirm ? 'is-invalid' : ''}`} value={form.emailConfirm} onChange={handleChange} />
                                                {errors.emailConfirm && <div className="invalid-feedback">{errors.emailConfirm}</div>}
                                            </div>
                                        </div>

                                        <div className="row g-3 mb-4">
                                            <div className="col-md-6">
                                                <label className="form-label">Telephone Number *</label>
                                                <input type="tel" name="phone" className={`form-control ${errors.phone ? 'is-invalid' : ''}`} value={form.phone} onChange={handleChange} />
                                                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <button className="btn text-white" style={{ backgroundColor: BRAND }} onClick={() => {
                                                if (validateStep1()) setStep(2);
                                            }}>
                                                Continue to Payment <i className="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </>
                                )}

                                {step === 2 && (
                                    <>
                                        <h5 className="fw-bold mb-3">Step 2: Payment</h5>

                                        <div className="alert alert-warning fw-bold" role="alert">
                                            <i className="fas fa-exclamation-circle me-2"></i>
                                            PAYMENT REQUIRED BEFORE SUBMISSION
                                        </div>
                                        <p className="text-muted mb-4">
                                            You must complete your payment before reviewing and submitting your CPD registration application. Click the red “PAY HERE” button below to make your payment. After completing the payment, return to this page and enter your MoMo Payment Transaction ID.
                                        </p>

                                        <div className="text-center mb-4">
                                            <a
                                                href="https://paystack.shop/pay/arca_member"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-danger btn-lg fw-bold px-5 py-3"
                                                style={{ backgroundColor: '#C0392B', borderColor: '#C0392B', fontSize: '1.25rem' }}
                                            >
                                                <i className="fas fa-credit-card me-2"></i>PAY HERE
                                            </a>
                                        </div>

                                        <div className="alert alert-info" role="alert">
                                            <strong>SUBMIT YOUR APPLICATION AFTER PAYMENT</strong><br />
                                            After completing your payment, return to this page, enter your MoMo Payment Transaction ID, and continue to review and submit your application.
                                        </div>

                                        <h6 className="fw-bold mb-3">MoMo Payment Transaction ID *</h6>
                                        <div className="mb-4">
                                            <input
                                                type="text"
                                                name="momoTransactionId"
                                                className={`form-control ${errors.momoTransactionId ? 'is-invalid' : ''}`}
                                                value={form.momoTransactionId}
                                                onChange={handleChange}
                                                placeholder="Enter the Mobile Money transaction ID you received after completing your payment."
                                            />
                                            {errors.momoTransactionId && <div className="invalid-feedback">{errors.momoTransactionId}</div>}
                                            <div className="form-text">Enter the Mobile Money transaction ID you received after completing your payment.</div>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <button className="btn btn-outline-secondary" onClick={() => setStep(1)}>
                                                <i className="fas fa-arrow-left me-2"></i>Back
                                            </button>
                                            <button className="btn text-white" style={{ backgroundColor: BRAND }} onClick={() => {
                                                if (validateStep1() && validateStep2()) setStep(3);
                                            }}>
                                                Continue to Review <i className="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </>
                                )}

                                {step === 3 && (
                                    <>
                                        <h5 className="fw-bold mb-3">Step 3: Review Your Application</h5>

                                        <div className="table-responsive mb-4">
                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr><td className="fw-bold" style={{ width: '40%' }}>Full Name</td><td>{`${form.firstName} ${form.middleName ? form.middleName + ' ' : ''}${form.lastName}`}</td></tr>
                                                    <tr><td className="fw-bold">Gender</td><td>{form.gender}</td></tr>
                                                    <tr><td className="fw-bold">Professional Governing Body</td><td>{form.governingBody}</td></tr>
                                                    <tr><td className="fw-bold">Profession</td><td>{form.profession === 'Others' ? form.professionOther : (form.governingBody === 'AHPC' ? ahpcProfessions.find(p => p.value === form.profession)?.label : nmcProfessions.find(p => p.value === form.profession)?.label)}</td></tr>
                                                    <tr><td className="fw-bold">{form.governingBody === 'NMC' ? 'NMC PIN/Professional Registration Number' : 'AHPC PIN'}</td><td>{form.pin}</td></tr>
                                                    <tr><td className="fw-bold">Primary Email Address</td><td>{form.email}</td></tr>
                                                    <tr><td className="fw-bold">Telephone Number</td><td>{form.phone}</td></tr>
                                                    <tr><td className="fw-bold">MoMo Payment Transaction ID</td><td>{form.momoTransactionId}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <button className="btn btn-outline-secondary" onClick={() => setStep(2)}>
                                                <i className="fas fa-arrow-left me-2"></i>Edit Information
                                            </button>
                                            <button className="btn text-white" style={{ backgroundColor: BRAND }} onClick={handleSubmit} disabled={submitting}>
                                                {submitting ? 'Submitting...' : 'Confirm and Submit Application'}
                                            </button>
                                        </div>
                                    </>
                                )}

                                {step === 4 && submitted && (
                                    <div className="text-center py-5">
                                        <i className="fas fa-check-circle mb-3" style={{ fontSize: '64px', color: BRAND }}></i>
                                        <h3 className="fw-bold mb-3" style={{ color: '#4A4F4F' }}>Application Submitted Successfully</h3>
                                        <p className="text-muted mb-4">
                                            Thank you for registering for the Respiratory Care Month 2026 Webinar Series. Your application has been received and will be processed.
                                        </p>
                                        <Link to="/events" className="btn text-white" style={{ backgroundColor: BRAND }}>
                                            Back to Events
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
};

export default CpdRegistrationPage;
